import api from "@/plugins/api/EntryPoint";

export default {
  /**
   * ✅ НОВЫЙ МЕТОД: Запрашивает данные счета через Puppeteer
   * @param {object} payload - { username, password }
   * @param {function} cb - Callback
   */
  /**
   * ✅ ОБНОВЛЕННЫЙ МЕТОД: Запрашивает данные счета через Puppeteer
   * @param {object} payload - { username, password, account_id }
   * @param {function} cb - Callback
   * @param {string} sessionId - Идентификатор сессии (опционально)
   */
  scrapeAccountDetails(payload, cb, sessionId = null) {
    const store = require("@/store").default;

    // Ограничиваем до 2 попыток
    const MAX_RETRIES = 2;
    let retryCount = 0;

    const makeRequest = (reqData, isRetry = false) => {
      // Прекращаем попытки, если достигнут лимит
      if (isRetry && retryCount >= MAX_RETRIES) {
        console.log(
          `Достигнут лимит попыток (${MAX_RETRIES}), остаемся на текущей странице`
        );
        cb({ status: "error", message: "Достигнут лимит попыток" });
        return;
      }

      if (isRetry) {
        retryCount++;
        console.log(`Повторная попытка #${retryCount} из ${MAX_RETRIES}`);
      }

      const rawCreds = JSON.parse(
        JSON.stringify(store.state.Auth.userCredentials || "{}")
      );
      console.log(
        "makeRequest в /auth:",
        reqData,
        "userCredentials:",
        rawCreds
      );

      // Убедимся, что запрос содержит account_id при наличии
      if (payload && payload.account_id && !reqData.account_id) {
        console.log("Добавляю account_id в запрос:", payload.account_id);
        reqData.account_id = payload.account_id;
      }

      api
        .post(
          "auth",
          reqData,
          (response) => {
            // Не вызываем afterLogin при повторном входе, чтобы избежать перенаправления
            // Просто вернем результат без перенаправления
            if (isRetry && response && response.status === "success") {
              console.log("Успешный повторный вход без перенаправления");
              // Устанавливаем session_id, но не вызываем перенаправление
              if (response.session_id) {
                store.commit("Auth/SET_SESSION_ID", response.session_id);
              }
            }
            cb(response);
          },
          false,
          true
        )
        .catch((error) => {
          // Проверяем на ошибку 500 и Network Error
          if (!isRetry) {
            if (error.response && error.response.status === 500) {
              // Сессия истекла, делаем повтор
              console.log(
                "Ошибка 500 (вероятно, сессия истекла), повторяю с credentials..."
              );
              store.commit("Auth/SET_SESSION_ID", null);
              const retryData = {
                username: rawCreds.username,
                password: rawCreds.password,
              };

              // Сохраняем account_id при повторе
              if (payload && payload.account_id) {
                retryData.account_id = payload.account_id;
              }

              makeRequest(retryData, true);
            } else if (
              error.message &&
              error.message.includes("Network Error")
            ) {
              // Сетевая ошибка, сервер недоступен
              console.log(
                "Сетевая ошибка. Остаемся на текущей странице без перенаправлений"
              );
              // Вернем ошибку, но не делаем перенаправлений
              cb({ status: "error", message: "Network Error" });
            } else {
              console.error(
                "Ошибка в scrapeAccountDetails, не связанная с сессией:",
                error
              );
              cb(error.response && error.response.data);
            }
          } else {
            // Это ошибка при повторной попытке, возвращаем и остаемся на текущей странице
            console.error("Ошибка при повторной попытке:", error);
            cb(error.response && error.response.data);
          }
        });
    };

    let data;
    if (sessionId) {
      data = { session_id: sessionId };
      // Добавляем account_id, если он есть в payload
      if (payload && payload.account_id) {
        data.account_id = payload.account_id;
      }
    } else {
      data = JSON.parse(
        JSON.stringify(store.state.Auth.userCredentials || "{}")
      );
      // Добавляем account_id, если он есть в payload
      if (payload && payload.account_id) {
        data.account_id = payload.account_id;
      }
    }
    console.log("Отправляю запрос с данными:", data);
    makeRequest(data);
  },

  // ✅ НОВЫЙ МЕТОД РЕГИСТРАЦИИ
  async register(payload) {
    console.log("Отправка запроса на /api/register:", payload);
    // Последний параметр `true`  означает, что мы используем новый API (VUE_APP_NEW_API_URL)
    return await api.post("register", payload, null, false, true);
  },

  // --- остальные ваши методы ---

  // старый метод аутентификации
  authenticate(cb) {
    return api.post("userAuth", cb);
  },

  // получение телефона
  async getPhoneNumber(callBackFn) {
    await api.get(`settings/phone`, callBackFn);
  },

  // 🚀 новый сценарий входа → сразу тянем список счетов
  async loginV2({ username, password }) {
    console.log("Отправка запроса loginV2 (bills):", { username, password });
    const response = await api.post(
      "bills",
      { username, password },
      null,
      false,
      true
    );
    return response.data; // вернёт { bills: [...] }
  },

  // ✅ алиас
  async login({ email, password, username }) {
    return this.loginV2({
      username: username || email,
      password,
    });
  },
};
